<template>
  <div
    class="window-container"
    :class="{ portrait: isPortrait, trimming: isTrimming }"
    :style="{ height: height }">
    <router-view v-slot="{ Component, route }">
      <transition
        mode="out-in"
        :name="transitionName">
        <keep-alive :include="cacheView">
          <component
            :is="Component"
            :key="route.path"></component>
        </keep-alive>
      </transition>
    </router-view>
  </div>
</template>
<script lang="ts" setup>
import { ref, watch, onBeforeUnmount, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { indexStore } from "@/store";
import { permissionStore } from "@/store/permission";
import registerStore from "@/store/register";
import { getDeviceInfo1, getUserDeviceType } from "./utils/public";

let router = useRouter();
let route = useRoute();
const register = registerStore();
let height = ref<string>("0");
let isPortrait = ref();
let isTrimming = ref(false);
const index = indexStore();
let transitionName = ref<string>("brother");
const cacheView = computed(() => {
  return permissionStore().cacheView;
});
const init = () => {
  if (window.orientation === 90) {
    height.value = document.body.offsetHeight + "px";
    isPortrait.value = true;
  } else {
    height.value = document.body.offsetHeight + "px";
    isPortrait.value = false;
    if (document.body.offsetWidth < 530) {
      isTrimming.value = false;
    } else {
      if (document.body.offsetWidth / window.innerHeight > 0.563) {
        isTrimming.value = true;
      } else {
        isTrimming.value = false;
      }
    }
  }
  if (window.localStorage.getItem("vsonsole")) {
    const el: HTMLElement | any = document.querySelector("#__vconsole");
    if (el) {
      el.style.display = "block";
    }
  }
};

// 过滤sso登录 #wechat_redirect 导致的白屏问题
window.location.href = decodeURIComponent(window.location.href).replace("#wechat_redirect", "");

watch(
  () => router.currentRoute.value.meta,
  (newValue, oldValue) => {
    // console.log(newValue, oldValue)

    index.setTitle(window._globalConfig?.rootNodeName || import.meta.env.VITE_APP_TITLE);
    index.setSubtitle("");
    index.setRight(false);
    index.setLeft(true);
    index.setBgColor("#FFFFFF");
    index.setIsShow(false);
    index.setIsShowHome(false);
    index.setShowTabbar(true);
    // console.log(oldValue && oldValue.tree, newValue && newValue.tree)
  },
  { immediate: true }
);
if (init) {
  register.registerColor();
  register.registerTheme();
  register.registerSpace();
  window.addEventListener("load", init);
  window.addEventListener("resize", init);
}
onBeforeUnmount(() => {
  if (init) {
    window.removeListener("load", init);
    window.removeListener("resize", init);
  }
});

window.addEventListener(
  "error",
  (event) => {
    // 过滤js error

    let target: any = event.target;
    let isElementTarget = target instanceof HTMLScriptElement || target instanceof HTMLLinkElement || target instanceof HTMLImageElement;
    if (!isElementTarget) return false;
    let url = target.src || target.href;
    console.error(url + "资源加载错误");
  },
  true
);
</script>

<style>
.window-container {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;

  width: 100%;
}

.window-container.portrait {
  overflow: scroll;
}

#app {
  position: relative;
  overflow: hidden;
  width: 100vw;
  min-height: 100vh;
  overscroll-behavior: none;
}

#__vconsole {
  display: none;
}
</style>
